var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.625C8.99449 0.661468 6.12235 1.87161 3.99698 3.99698C1.87161 6.12235 0.661468 8.99449 0.625 12C0.661468 15.0055 1.87161 17.8776 3.99698 20.003C6.12235 22.1284 8.99449 23.3385 12 23.375C15.0055 23.3385 17.8776 22.1284 20.003 20.003C22.1284 17.8776 23.3385 15.0055 23.375 12C23.3385 8.99449 22.1284 6.12235 20.003 3.99698C17.8776 1.87161 15.0055 0.661468 12 0.625ZM18.5 12.8125H12.8125V18.5H11.1875V12.8125H5.5V11.1875H11.1875V5.5H12.8125V11.1875H18.5V12.8125Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/addPlus.8dfdf81cdce753b5178a8bc7a0ed17a6.svg";
export { ForwardRef as ReactComponent };